/* AUTO-GENERATED FILE — DO NOT EDIT
 * Generated by tools/registry/generate-modules.ts
 */

export type EntryUrl = { type: "url"; url: string };
export type EntryRoute = { type: "route"; route: string };
export type EntryMf = { type: "mf"; remote: string; module: string; export?: string };
export type Entry = EntryUrl | EntryRoute | EntryMf;

export type Status = "active" | "beta" | "alpha" | "legacy";
export type Category = "system" | "assessment" | "tax" | "mapping" | "records" | "analytics" | "ai";
export type Intent = "gen2" | "legacy" | "archive";

export type ModuleManifest = {
  id: string;
  displayName: string;
  description: string;
  iconName: string;
  category: Category;
  tier: number;
  status: Status;
  pinned: boolean;
  version: string;
  intent: Intent;
  runnable: boolean;
  entry: Entry;
  tags?: string[];
  permissions?: string[];
};

export const GENERATED_MODULES: readonly ModuleManifest[] = [
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "costforge-ai",
    "displayName": "CostForge AI",
    "description": "AI-Driven Cost Estimation & RCNLD Analysis (Legacy Standalone)",
    "iconName": "Building2",
    "category": "assessment",
    "tier": 1,
    "status": "legacy",
    "pinned": false,
    "version": "2.1.0",
    "intent": "legacy",
    "runnable": true,
    "entry": {
      "type": "url",
      "url": "http://localhost:5176/"
    },
    "tags": [
      "assessment",
      "cost",
      "rcnld",
      "ai",
      "legacy"
    ],
    "permissions": [
      "county:read",
      "property:read",
      "property:write"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "gis-pro",
    "displayName": "TerraGIS",
    "description": "Gen2 Geographic Information System & Parcel Mapping",
    "iconName": "Map",
    "category": "mapping",
    "tier": 1,
    "status": "active",
    "pinned": true,
    "version": "4.0.0",
    "intent": "gen2",
    "runnable": true,
    "entry": {
      "type": "url",
      "url": "http://localhost:5178/"
    },
    "tags": [
      "gis",
      "mapping",
      "parcels",
      "geospatial",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "gis:read",
      "gis:write"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "os-shell",
    "displayName": "TerraFusion OS Shell",
    "description": "Primary TerraFusion OS Shell (Vite dev server)",
    "iconName": "Desktop",
    "category": "system",
    "tier": 1,
    "status": "active",
    "pinned": false,
    "autostart": true,
    "version": "1.0.0",
    "intent": "archive",
    "runnable": true,
    "runtime": "pnpm",
    "start": {
      "cmd": "pnpm",
      "args": [
        "run",
        "dev",
        "--",
        "--open"
      ],
      "cwd": "frontend"
    },
    "entry": {
      "type": "url",
      "url": "http://localhost:5173/"
    },
    "tags": [
      "shell",
      "desktop",
      "os"
    ],
    "permissions": []
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-dossier",
    "displayName": "TerraDossier",
    "description": "Gen2 Sovereign Document Management & Defense Packets",
    "iconName": "FileSearch",
    "category": "records",
    "tier": 1,
    "status": "active",
    "pinned": true,
    "autostart": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": true,
    "runtime": "deno",
    "start": {
      "cmd": "deno",
      "args": [
        "task",
        "dev"
      ]
    },
    "entry": {
      "type": "url",
      "url": "http://localhost:3007/"
    },
    "tags": [
      "records",
      "documents",
      "dossier",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "documents:read",
      "documents:write"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-flow",
    "displayName": "TerraFlow",
    "description": "Gen2 Workflow & Process Automation Engine",
    "iconName": "GitBranch",
    "category": "system",
    "tier": 1,
    "status": "beta",
    "pinned": true,
    "version": "2.0.0",
    "intent": "gen2",
    "runnable": true,
    "entry": {
      "type": "url",
      "url": "http://localhost:5183/"
    },
    "tags": [
      "workflow",
      "automation",
      "process",
      "gen2"
    ],
    "permissions": [
      "system:admin"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-gama",
    "displayName": "TerraGAMA",
    "description": "Gen2 Geographic Area Market Analysis",
    "iconName": "BarChart3",
    "category": "analytics",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "2.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "url",
      "url": "http://localhost:5182/"
    },
    "tags": [
      "analytics",
      "market",
      "gama",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "analytics:read"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-levy",
    "displayName": "TerraLevy",
    "description": "Gen2 Tax Levy Management & Rate Calculations",
    "iconName": "Calculator",
    "category": "tax",
    "tier": 1,
    "status": "beta",
    "pinned": true,
    "version": "2.0.0",
    "intent": "gen2",
    "runnable": true,
    "entry": {
      "type": "url",
      "url": "http://localhost:5177/"
    },
    "tags": [
      "tax",
      "levy",
      "rates",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "tax:read",
      "tax:write"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-permit",
    "displayName": "TerraPermit",
    "description": "Gen2 Building Permit Tracking & Valuation Updates",
    "iconName": "HardHat",
    "category": "assessment",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "2.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "url",
      "url": "http://localhost:5181/"
    },
    "tags": [
      "permits",
      "construction",
      "assessment",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "permits:read",
      "permits:write"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-pilt",
    "displayName": "TerraPILT",
    "description": "Gen2 Payment in Lieu of Taxes Calculator",
    "iconName": "Landmark",
    "category": "tax",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "2.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "url",
      "url": "http://localhost:5179/"
    },
    "tags": [
      "tax",
      "pilt",
      "federal",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "tax:read"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terra-primeview",
    "displayName": "TerraPrime",
    "description": "Gen2 Property Data Viewer & Inspector",
    "iconName": "Eye",
    "category": "records",
    "tier": 1,
    "status": "active",
    "pinned": true,
    "version": "2.0.0",
    "intent": "gen2",
    "runnable": true,
    "entry": {
      "type": "url",
      "url": "http://localhost:5184/"
    },
    "tags": [
      "records",
      "viewer",
      "property",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "terraforge",
    "displayName": "TerraForge",
    "description": "AI-Powered Cost Calculation & Valuation Modeling Suite",
    "iconName": "Layers",
    "category": "assessment",
    "tier": 1,
    "status": "active",
    "pinned": true,
    "autostart": false,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": true,
    "runtime": "node",
    "start": {
      "cmd": "pnpm",
      "args": [
        "dev"
      ]
    },
    "entry": {
      "type": "url",
      "url": "http://localhost:4201/"
    },
    "tags": [
      "assessment",
      "valuation",
      "cost",
      "ai",
      "gen2"
    ],
    "permissions": [
      "county:read",
      "property:read",
      "property:write"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "income-valuation",
    "displayName": "Income Valuation",
    "description": "Income approach property valuation — direct capitalization, GRM, and AI-assisted NOI analysis. Legacy: BSIncomeValuation (React/Express/Drizzle). ARCHIVED: Capability absorbed into Forge → Income sub-tab via IncomeValuationPanel + incomeValuationService.ts.",
    "iconName": "TrendingUp",
    "category": "assessment",
    "tier": 1,
    "status": "alpha",
    "pinned": false,
    "version": "2.0.0",
    "intent": "archive",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "assessment",
      "income",
      "valuation",
      "gen2",
      "parcel-scoped"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "id": "regression-studio",
    "displayName": "Regression Studio",
    "description": "County-wide MRA regression models for mass appraisal — multiple regression analysis, model diagnostics, IAAO compliance. Legacy: Bsbcintelligentvalues (FastAPI/scikit-learn).",
    "iconName": "LineChart",
    "category": "assessment",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "assessment",
      "regression",
      "mra",
      "gen2",
      "county-wide"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "id": "statistics-studio",
    "displayName": "Statistics Studio",
    "description": "County-wide ratio studies — COD, COV, PRD, weighted mean ratios, IAAO Standard on Ratio Studies compliance. Legacy: assessment workflow tools.",
    "iconName": "PieChart",
    "category": "analytics",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "analytics",
      "statistics",
      "ratio-studies",
      "gen2",
      "county-wide"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "id": "comparable-sales",
    "displayName": "Comparable Sales",
    "description": "Parcel-scoped sales comparison approach — neighborhood comps, paired adjustments, Leaflet mapping, USPAP-compliant exports. Legacy: GeospatialAnalyzerBS. ARCHIVED: Capability absorbed into Forge → Sales sub-tab via ComparableSalesPanel + comparableSalesService.ts.",
    "iconName": "Home",
    "category": "assessment",
    "tier": 1,
    "status": "beta",
    "pinned": false,
    "version": "1.1.0",
    "intent": "archive",
    "runnable": true,
    "entry": {
      "type": "component",
      "route": "/workbench/forge"
    },
    "tags": [
      "assessment",
      "comps",
      "sales-comparison",
      "gen2",
      "parcel-scoped",
      "rehosted"
    ],
    "permissions": [
      "county:read",
      "property:read",
      "gis:read"
    ]
  },
  {
    "id": "vei",
    "displayName": "VEI",
    "description": "Vertical Equality Index — measures assessment progressivity/regressivity across value ranges, PRB analysis, IAAO equity compliance.",
    "iconName": "Search",
    "category": "assessment",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "assessment",
      "equity",
      "vertical-equality",
      "prb",
      "gen2",
      "county-wide"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "id": "property-tax-ai",
    "displayName": "PropertyTax AI",
    "description": "AI-powered assessment assistant — LangChain agents for valuation analysis, appeal preparation, and automated property review. Legacy: PropertyTaxAI.",
    "iconName": "Bot",
    "category": "ai",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "ai",
      "assessment",
      "langchain",
      "gen2",
      "county-wide"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "id": "pacs-bridge",
    "displayName": "County Data Bridge",
    "description": "System/admin — import/export bridge for county assessment systems, data sync, and field mapping.",
    "iconName": "Cable",
    "category": "system",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "system",
      "pacs",
      "integration",
      "gen2",
      "admin"
    ],
    "permissions": [
      "system:admin",
      "county:read",
      "property:read",
      "property:write"
    ]
  },
  {
    "id": "terra-sync",
    "displayName": "TerraSync",
    "description": "System/admin — county data synchronization & ETL pipelines, multi-source ingestion, conflict resolution. Legacy: TerraFusionSync, CountyDataSync.",
    "iconName": "RefreshCw",
    "category": "system",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "system",
      "sync",
      "etl",
      "gen2",
      "admin"
    ],
    "permissions": [
      "system:admin",
      "county:read"
    ]
  },
  {
    "id": "terra-miner",
    "displayName": "TerraMiner",
    "description": "Property research & outside data mining — aggregates external recorder, permit, and assessor feeds for parcel enrichment. Legacy: TerraMiner (Private).",
    "iconName": "Search",
    "category": "assessment",
    "tier": 1,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "assessment",
      "research",
      "data-mining",
      "gen2",
      "county-wide"
    ],
    "permissions": [
      "county:read",
      "property:read"
    ]
  },
  {
    "id": "legislative-pulse",
    "displayName": "Legislative Pulse",
    "description": "Legislative research & tracking — monitors WA state bills, fiscal notes, and policy impacts on county assessment/taxation. Legacy: legislative-pulse-beacon (Private).",
    "iconName": "Megaphone",
    "category": "policy",
    "tier": 2,
    "status": "alpha",
    "pinned": true,
    "version": "1.0.0",
    "intent": "gen2",
    "runnable": false,
    "entry": {
      "type": "route",
      "route": "/placeholder"
    },
    "tags": [
      "policy",
      "legislative",
      "research",
      "gen2",
      "county-wide"
    ],
    "permissions": [
      "county:read"
    ]
  },
  {
    "$schema": "../../tools/registry/terrafusion.app.schema.json",
    "id": "webhub",
    "displayName": "WebHub",
    "description": "County Web Portal & Public Interface Hub",
    "iconName": "Globe",
    "category": "system",
    "tier": 2,
    "status": "legacy",
    "pinned": false,
    "version": "1.0.0",
    "intent": "legacy",
    "runnable": false,
    "entry": {
      "type": "url",
      "url": "http://localhost:5185/"
    },
    "tags": [
      "portal",
      "public",
      "web",
      "legacy"
    ],
    "permissions": [
      "county:read"
    ]
  }
] as const;

export type GeneratedModule = (typeof GENERATED_MODULES)[number];
